import { render, staticRenderFns } from "./MerchantView.vue?vue&type=template&id=392c58d1&scoped=true"
import script from "./MerchantView.vue?vue&type=script&lang=js"
export * from "./MerchantView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c58d1",
  null
  
)

export default component.exports